var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{class:_vm.layoutClass,attrs:{"items":_vm.items,"divider":"/"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"to":{ name: item.name },"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }